import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";

export default function PosterCard({ item }: { item: ContentItem }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group rounded-xl bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="aspect-[3/4] w-full overflow-hidden">
        <img
          src={item.cover}
          alt={item.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-3.5">
        <div className="flex items-center justify-between gap-2 mb-1.5">
          <h3 className="text-sm md:text-base font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
          <span className="text-xs text-foreground-400 shrink-0">
            {item.year}
          </span>
        </div>
        <span className="inline-block text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 mb-2">
          {item.genre}
        </span>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
          {item.summary}
        </p>
      </div>
    </Link>
  );
}